import { render, staticRenderFns } from "./AddNJBPage.vue?vue&type=template&id=5a1416f6&scoped=true&"
import script from "./AddNJBPage.vue?vue&type=script&lang=js&"
export * from "./AddNJBPage.vue?vue&type=script&lang=js&"
import style0 from "./AddNJBPage.vue?vue&type=style&index=0&id=5a1416f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1416f6",
  null
  
)

export default component.exports